<template>
  <div
    class="erank-logo flex h-[60px] items-center justify-center bg-[--v3-theme-primarycolor] transition-all duration-150"
    :class="{
      'w-[50px]': collapsed,
      'w-[277px]': !collapsed,
    }"
  >
    <Icon
      v-if="collapsed"
      name="erank-mini"
      :width="20"
      :height="24"
    />
    <div
      v-else
      class="flex w-full items-center pl-[18px]"
      :class="className"
    >
      <img
        src="/img/logo-light.svg"
        class="h-[25px]"
        style="shape-rendering: crispEdges;"
        alt="Erank Logo"
      >
      <img
        v-if="labelImage"
        :src="labelImage"
        class="mt-[4px] h-[14px]"
        alt="Logo"
      >
    </div>
  </div>
</template>

<script setup lang='ts'>
import { computed } from 'vue';

import Icon from '@/common/components/atoms/Icon';
import type { Plan } from '@/types/global';

const props = withDefaults(defineProps<{
  collapsed?: boolean;
  plan: Plan;
  className?: string;
}>(), {
  collapsed: false,
  className: 'justify-start',
});


const labelImage = computed(() => {
  switch (props.plan) {
    case 'pro':
      return '/img/pro-label-tangerine.svg';
    case 'basic':
      return '/img/basic-label-tangerine.svg';
    case 'expert':
      return '/img/expert-label-tangerine.svg';
    default:
      return '';
  }
});
</script>


